import { createContext } from 'react';

const MultilocationContext = createContext();
MultilocationContext.displayName = 'MultilocationContext';

export default MultilocationContext;
